import React from 'react';


const PaymentMethod = () => {

  const PaymentMethods = [
    {
      name: 'Debit/Credit Card',
      icon: '/images/icons/visa.svg',
      checked: 'true',
    },
    {
      name: 'UPI',
      icon: '/images/icons/upi.svg',
      checked: 'false',
    },
    {
      name: 'Wallet',
      icon: '/images/icons/wallet.svg',
      checked: 'false',
    },
    {
      name: 'Net Banking',
      icon: '/images/icons/net-banking.svg',
      checked: 'false',
    },
  ]

  return (
    <>
      <section className='row w-100 mx-auto mb-3 position-relative'>
        {/* Left Block */}
        <div className='col-12 col-md-8 px-0 pe-md-3 mb-3'>
          {/* Select Page */}
          <div className='bg-light d-flex gap-2 p-3 rounded-3 shadow-sm mb-3'>
            <img src="/images/icons/add-payment-method.svg" style={{ height: '25px' }} alt="icon" />

            <div className='flex-grow-1'>
              <h5 className='mb-0'>Select Page</h5>

              <p className='my-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, excepturi.</p>

              <select className="form-select">
                <option selected>Open this select menu</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
          </div>

          {/* Add Payment Method & Billing Details */}
          <div className='bg-light p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Add Payment Method & Billing Details</h5>

            <p className='mt-1 mb-4'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum doloribus cumque soluta totam at minus nulla, sit officiis omnis molestias aliquam, neque a laudantium unde quidem veniam suscipit repellat perspiciatis. <span className='text-primary'>Learn More...</span></p>

            <div>
              {
                PaymentMethods.map((value, index) => (
                  <div className="form-check form-check-reverse text-start mb-3" key={index}>
                    <label className="form-check-label fw-semibold me-2" htmlFor={`payment-method-${index}`}>{value.name}</label>

                    <img src={value.icon} style={{ height: '20px' }} alt="icon" />

                    <input type="radio" className="form-check-input" name="payment-methods" id={`payment-method-${index}`} checked={value.checked === 'true'} />
                  </div>
                ))
              }
            </div>
          </div>

          {/* Time Zone */}
          <div className='bg-light p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Time Zone</h5>

            <p className='my-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, excepturi.</p>

            <select className="form-select">
              <option selected>Open this select menu</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>

          {/* Currency */}
          <div className='bg-light p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Currency</h5>

            <p className='my-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, excepturi.</p>

            <select className="form-select">
              <option selected>Open this select menu</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>

          {/* Billing Name */}
          <div className='bg-light p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Billing Name</h5>

            <p className='mt-1 mb-3'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Porro, eum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit voluptatum, molestias officia minus voluptate eum cupiditate animi sit maiores magnam!</p>

            <div className='d-flex gap-3 flex-wrap align-items-center justify-content-between'>
              <div className='bg-white px-3 py-2 rounded-3 d-flex align-items-center gap-2 shadow-sm'>
                <img src="/images/icons/briefcase.svg" style={{ height: '17px' }} alt="pages" />

                <h6 className='mb-0 me-4'>Siddharth Dongre</h6>

                <small className='text-primary'>Edit</small>
              </div>

              <button type="button" className='btn btn-primary rounded-3'>Confirm</button>
            </div>
          </div>

          {/* Business Address & GST */}
          <div className='bg-light p-3 rounded-3 mb-3 d-flex gap-3 flex-wrap flex-sm-nowrap align-items-center justify-content-between'>
            <div>
              <h5 className='mb-1'>Business Address & GST</h5>

              <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste aspernatur expedita alias. Placeat suscipit distinctio nostrum voluptate harum asperiores exercitationem, optio quisquam, commodi in cum consectetur dolorum fugiat id dolor?</span>
            </div>

            <button type="button" className='btn btn-primary px-4'>Add</button>
          </div>

          {/* Business & GST Info */}
          <div className='bg-light p-3 rounded-3 mb-3'>
            <h4 className='mb-4'>Business & GST Info</h4>

            {/* Business Name */}
            <div className='mb-3'>
              <h5 className='mb-0'>Business Name</h5>

              <p className='my-2'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat, minima.</p>

              <input type="text" className='form-control' placeholder='Enter your business name...' />
            </div>

            {/* Business Info */}
            <div>
              <h5 className='mb-2'>Business Info</h5>

              <div className='d-flex gap-3 flex-column flex-sm-row'>
                <div className="flex-grow-1">
                  <label htmlFor="exampleFormControlInput1" className="form-label">GST Number</label>
                  <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="GST Number..." />
                </div>

                <div className="flex-grow-1">
                  <label htmlFor="exampleFormControlInput1" className="form-label">PAN Number</label>
                  <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="PAN Number..." />
                </div>
              </div>
            </div>

            <div className="form-check my-4">
              <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" defaultChecked />
              <label className="form-check-label" htmlFor="flexCheckDefault">Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse facere possimus explicabo, blanditiis voluptas, quo deserunt expedita velit eum porro perferendis. Voluptatibus nemo ducimus, deserunt sit placeat nobis quod totam!</label>
            </div>

            {/* Business Address */}
            <div className='mb-4'>
              <h5 className='mb-0'>Business Address</h5>

              <p className='mt-1 mb-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet saepe, maxime repellat fugiat quaerat eveniet recusandae velit in veritatis voluptate!</p>

              <input type="text" className='form-control mb-3' placeholder='Address Name...' />

              <input type="text" className='form-control mb-3' placeholder='Address Line 1...' />

              <input type="text" className='form-control mb-3' placeholder='Address Line 2...' />

              <select className="form-select mb-3">
                <option selected>Country</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>

              <select className="form-select mb-3">
                <option selected>State</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>

              <select className="form-select mb-3">
                <option selected>City/Town</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>

              <input type="text" className='form-control' placeholder='Pinconde...' />
            </div>

            {/* Ad Purpose */}
            <div>
              <h5 className='mb-3'>Ad Purpose</h5>

              <div className="form-check mb-2">
                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" defaultChecked />
                <label className="form-check-label" htmlFor="flexRadioDefault1">Yes, I am buying ads for business purpose.</label>
              </div>

              <div className="form-check mb-3">
                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                <label className="form-check-label" htmlFor="flexRadioDefault1">No, I am not buying ads for business purpose.</label>
              </div>

              <span><span className='text-primary'>eMilo</span> is required Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus, obcaecati!</span>
            </div>
          </div>

          <div className='bg-white p-3 rounded-3 mb-3'>
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" defaultChecked />
              <label className="form-check-label" htmlFor="defaultCheck1">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, ipsam. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta iusto eaque ipsa delectus assumenda, laudantium commodi facere harum sed qui obcaecati illo, ipsum cumque magni at sit, fuga soluta. Inventore, illo velit veritatis, autem consectetur, et fugit doloribus nostrum dignissimos rem necessitatibus illum. In labore incidunt vero ducimus voluptate. Repudiandae?</label>
            </div>
          </div>

          {/* Cancel & Save */}
          <div className='d-flex align-items-center justify-content-end gap-3'>
            <button type="button" className='btn bg-secondary-subtle px-4 px-sm-5'>Cancel</button>
            <button type="button" className='btn btn-primary px-4 px-sm-5'>Next</button>
          </div>
        </div>

        {/* Right Block */}
        <div className='col-12 col-md-4 px-0'>
          <div className='position-sticky' style={{ top: '5px' }}>
            {/* Payment History */}
            <div className='bg-white p-3 rounded-3 mb-3'>
              <h5 className='mb-0'>Payment History</h5>

              <p className='mt-1 mb-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, quisquam!</p>

              <div className='d-flex align-items-center gap-2'>
                <img src="/images/icons/page-blue.svg" style={{ height: '20px' }} alt="page" />

                <span className='text-primary cursor-pointer'>View transaction history</span>
              </div>
            </div>

            {/* Payment Activity */}
            <div className='bg-white p-3 rounded-3 mb-3'>
              <h5 className='mb-1'>Payment Activity</h5>

              <span>You have no recent spending. <span className='text-primary cursor-pointer'>Create Ad</span> </span>
            </div>
          </div>
        </div>
      </section> 
    </>
  )
}

export default PaymentMethod
